/// <reference path="DOMAttached.js" />
/// <reference path="Confirm.js" />
/// <reference path="UrlTemplate.js" />

class VimeoPlayer extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.vimeoPlayer = document.getElementById(this.options.vimeoIframe);
		this.showSubtitles = this.options.showSubtitles;
		this.autoplay = this.options.autoPlay;
		this.videoProgressKey = 'videoTimeElapsed_' + this.options.videoId + '_' + this.options.memberUUId;
		this.initializeListeners();

		try {
			this.player = new Vimeo.Player(this.vimeoPlayer);
		} catch (err) {
			MiaErrorPrompt(this.options.playerCreationError);
			throw new Error(err);
		}

		this.setVideoProgress();

		// Handle messages from Vimeo player
		this.player.on('progress', this.onVimeoPlayerLoadProgress.bind(this));

		this.player.on('timeupdate', this.onVimeoPlayerPlayProgress.bind(this));
		this.player.on('play', this.onVimeoPlayerPlay.bind(this));
		this.player.on('pause', this.onVimeoPlayerPause.bind(this));
		this.player.on('ended', this.onVimeoPlayerFinish.bind(this));
		this.player.ready().then(this.onVimeoPlayerReady(this.player));
	}

	/**
	 * Set video progress (if there is any) from the either local or session storage
	 */
	setVideoProgress() {
		this.player.setCurrentTime(this.getTimeWatched());
	}

	initializeListeners() {
		this.listeners = [];

		if (this.options.rewardUrl != undefined) {
			this.addListener(new RewardVideoListener(this.options.rewardTimeSpan, this.options.rewardUrl));
		}
		if (this.options.fullyWatchedUrl != undefined) {
			this.addListener(new ReportWatchedVideoListener(this.options.fullyWatchedUrl, this.options.duration, this.videoProgressKey));
		}
	}

	addListener(listener) {
		this.listeners.push(listener);
	}

	removeListener(listener) {
		var index = this.listeners.indexOf(listener);
		if (index != -1) {
			this.listeners.splice(index, 1);
		}
	}

	notifyListenersOnPlayProgress(currentSeconds) {
		var index;
		for (index = 0; index < this.listeners.length; index++) {
			this.listeners[index].onPlayProgress(currentSeconds);
		}
	}

	notifyListenersOnLoadProgress(percentage) {
		var index;
		for (index = 0; index < this.listeners.length; index++) {
			this.listeners[index].onLoadProgress(percentage);
		}
	}

	notifyListenersOnPlay() {
		var index;
		for (index = 0; index < this.listeners.length; index++) {
			this.listeners[index].onPlay();
		}
	}

	notifyListenersOnPause() {
		var index;
		for (index = 0; index < this.listeners.length; index++) {
			this.listeners[index].onPause();
		}
	}

	notifyListenersOnEnd() {
		var index;
		for (index = 0; index < this.listeners.length; index++) {
			this.listeners[index].onEnd();
		}
	}

	onVimeoPlayerReady(player) {
		player.setVolume("1.0");
		if (this.showSubtitles) {
			player.enableTextTrack("en");
		}

		// When disabling autoplay Safari breaks thumbnail of the video. Thus we simply don't autoplay.
		if (this.autoplay && !this.isSafari()) {
			player.play();
		}
	}

	onVimeoPlayerLoadProgress(data) {
		this.notifyListenersOnLoadProgress(data.percent * 100.0);
	}

	onVimeoPlayerPlayProgress(data) {
		this.notifyListenersOnPlayProgress(data.seconds);
	}
	
	onVimeoPlayerPlay() {
		this.notifyListenersOnPlay();
	}

	onVimeoPlayerPause() {
		this.notifyListenersOnPause();
	}

	onVimeoPlayerFinish() {
		this.notifyListenersOnEnd();
		// This is needed to reload the player (#11862)
		// Vimeo API method unload() isn't supported in HTML players, so we need to reset the url in the iFrame.
		// See https://stackoverflow.com/a/19719340
		this.player.element.src = this.player.element.src;
	}

	getDurationSeconds() {
		return this.options.duration;
	}

	isSafari() {
		var userAgent = navigator.userAgent.toLowerCase();
		return userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") == -1;
	}

	getTimeWatched() {
		var videoProgressFromLocalStorage = localStorage.getItem(this.videoProgressKey);
		var videoProgressFromSessionStorage = sessionStorage.getItem(this.videoProgressKey);
		if (!videoProgressFromLocalStorage && !videoProgressFromSessionStorage) {
			return 0;
		}

		return Math.max(videoProgressFromLocalStorage, videoProgressFromSessionStorage);
	}
}
